import { Box, styled } from '@mui/material'

export const StyledTextBox = styled(Box)(() => ({
  width: '45.6%',
  height: '100%',
  position: 'absolute',
  top: 0,
}))
